import { Controller } from "stimulus";

let Highcharts;

export default class extends Controller {
  static targets = ["chart", "spinner", "toolbar"];

  connect() {
    import("highcharts/highstock").then(res => {
      Highcharts = res;

      this.renderChart(this.chartTarget.dataset.initialUrl);
    });
  }

  renderChart(chartUrl) {
    fetch(chartUrl, { credentials: "same-origin" })
      .then(response => response.json())
      .then(data => {
        if (data === null) {
          return;
        }

        const seriesDataArray = data.series_data_array;

        seriesDataArray.forEach(function(el) {
          el["type"] = "area";
        });

        Highcharts.chart(this.chartTarget.id, {
          time: { useUTC: false },
          title: "",
          credits: {
            enabled: false
          },
          tooltip: {
            shared: true,
            useHTML: true,
            pointFormat:
              "<span style='color:{point.color}'>\u25CF</span> {series.name}: <b>{point.y}%</b><br/>",
            xDateFormat: "%a %d %b %Y, %H:%M:%S"
          },
          xAxis: {
            type: "datetime",
            title: {
              enabled: false
            }
          },
          yAxis: {
            title: {
              text: "Dominance Percentage"
            },
            labels: {
              formatter: function() {
                return `${this.value}%`;
              }
            },
            max: 100
          },
          plotOptions: {
            area: {
              stacking: null,
              lineColor: "#666666",
              lineWidth: 1,
              marker: {
                enabled: false
              },
              connectNulls: true
            }
          },
          series: seriesDataArray
        });
      });
  }

  updateChart(e) {
    const buttonEl = e.currentTarget;

    // Clear active on siblings
    const $buttonEl = $(buttonEl);
    $buttonEl.siblings().removeClass("active");
    $buttonEl.addClass("active");

    this.chartDataUrl = $buttonEl.data("coin-dominance-url");
    this.renderChart(this.chartDataUrl);
  }
}



// WEBPACK FOOTER //
// ./app/assets/webpack/controllers/coin_dominance_chart_controller.js